import ContainerContent from './ContainerContent';

export default ContainerContent;
